import { colors } from './colors';
import { col, fontWeight, mq } from './helpers';
import styled from '@emotion/styled';
import { Devices } from './tokens';
import Cross from '@assets/svg/plus.svg';
/**
 * Icons
 */
import Missing from '@assets/svg/match/missing.svg';
import Attending from '@assets/svg/match/attending.svg';
import Reset from '@assets/svg/match/reset.svg';
import Late from '@assets/svg/match/late.svg';
import AllMissing from '@assets/svg/match/all_missing.svg';
import AllReset from '@assets/svg/match/all_reset.svg';
import AllAttending from '@assets/svg/match/all_attending.svg';
import UserSecret from '@assets/svg/settings/user-secret.svg';
import Clipboard from '@assets/svg/confirm.svg';
import ConfirmWithCheck from '@assets/svg/confirm-with-mark.svg';
import ConfirmWithCross from '@assets/svg/confirm-with-cross.svg';
import ConfirmMarkSmall from '@assets/svg/confirmed-mark-small.svg';

export const Theme = {
  DARK: 'dark',
  LIGHT: 'light',
};

/**
 * !! Only use these from now on
 */

export const MissingIcon = Missing;
export const AttendingIcon = Attending;
export const ResetIcon = Reset;
export const LateIcon = Late;
export const AllMissingIcon = AllMissing;
export const AllResetIcon = AllReset;
export const AllAttendingIcon = AllAttending;
export const UserSecretIcon = UserSecret;
export const ClipboardIcon = Clipboard;
export const ConfirmMarkSmallIcon = ConfirmMarkSmall;
export const ConfirmWithCheckIcon = styled(ConfirmWithCheck)`
  transform: translate(11%, 0%);
`;
export const ConfirmWithCrossIcon = styled(ConfirmWithCross)`
  transform: translate(11%, 0%);
`;
export const PrivacyIcon = UserSecret;

/**
 * Headers
 */
export const Heading1 = styled.h1`
  font-size: ${(props) => props.theme.fontSizes.large}px;
`;

export const Heading2 = styled.h2`
  font-size: ${(props) => props.theme.fontSizes.medium}px;
`;

export const Heading3 = styled.h3<{ bold?: boolean }>`
  font-size: ${(props) => props.theme.fontSizes.small}px;
  font-weight: ${(props) => (props.bold ? fontWeight.bold : fontWeight.regular)};
`;

export const TinyText = styled.div<{ bold?: boolean }>`
  font-size: ${(props) => props.theme.fontSizes.tiny}px;
  font-weight: ${(props) => (props.bold ? fontWeight.bold : fontWeight.regular)};
`;

export const TinyBoldText = styled.div`
  font-size: ${(props) => props.theme.fontSizes.tiny}px;
  font-weight: ${fontWeight.bold};
`;

export const SmallText = styled.div<{ bold?: boolean }>`
  font-size: ${(props) => props.theme.fontSizes.small}px;
  font-weight: ${(props) => (props.bold ? fontWeight.bold : fontWeight.regular)};
  > svg{
    height: 20px;
    padding-right: 12px;
    cursor: pointer;
    rect{
      fill: #4e4e4eff;
      
    }
  }
`;

export const SmallBoldText = styled.div`
  font-size: ${(props) => props.theme.fontSizes.small}px;
  font-weight: ${fontWeight.bold};
`;

export const MediumText = styled.div`
  font-size: ${(props) => props.theme.fontSizes.medium}px;
`;

export const MediumBoldText = styled.div`
  font-size: ${(props) => props.theme.fontSizes.medium}px;
`;

/**
 * Shadows
 */
export const Shadow = styled.div<{ size: number; opacity?: number; rounding?: number }>`
  background-color: #000000;
  opacity: ${(props) => (props.opacity ? props.opacity : (props) => props.theme.layout.shadowOpacity)};
  position: absolute;
  top: -${(props) => props.size}px;
  left: -${(props) => props.size}px;
  border-radius: ${(props) => (props.rounding ? props.rounding : (props) => props.theme.pillBorderRadius)}px;
  width: calc(100% + ${(props) => props.size}px * 2);
  height: calc(100% + ${(props) => props.size}px * 2);
  z-index: -1;
  pointer-events: none;
`;

/**
 * Layout
 */
export const absoluteCenter = `
 position: absolute;
 top:50%;
 left:50%;
 transform:translate(-50%,-50%);
`;

export const hideScrollbar = `
  &::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
`;

/**
 * End of clean up
 */

export const heading3style = `
    display:block;
    margin-top:4px;
    font-size:15px;
    color:${(props) => props.theme.colors.mainTextColor};
    font-weight: ${fontWeight.regular};
    `;

export const ResetIcon2 = styled(Cross)`
  width: 14px;
  height: 100%;
  margin-left: 10px;
  transform: rotate(45deg);
  margin-top: -1px;
  cursor: pointer;

  path {
    fill: ${(props) => props.theme.colors.mainTextColor};
    stroke: ${(props) => props.theme.colors.mainTextColor};
  }
`;

export const absolutePosition = ` position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;`;

export const fixedPosition = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`;

export const placeholder = (content) => `
  &::-webkit-input-placeholder {
    ${content};
  }
  &:-moz-placeholder {
    ${content};
  }
  &::-moz-placeholder {
    ${content};
  }
  &:-ms-input-placeholder {
    ${content};
  }
`;

export const glassStyle = `
  background-color: rgba(255, 255, 255, 0.8);
  // box-shadow: 6px 6px 25px #00000029;
`;

const baseH4 = `
    font-size: ${(props) => props.theme.fontSizes.small}px;
`;

export const heading4style = ` 
  ${baseH4}
  font-weight: ${fontWeight.bold};
  `;

export const semiHeading4style = ` 
    ${baseH4}
    font-weight: ${fontWeight.semiBold};
    `;

export const pageHeading = ` 
  color: ${(props) => props.theme.colors.mainTextColor};
  font-size: 18px;
  font-weight: ${fontWeight.light};
  `;

export const cardStyle = `
    position: relative;
    display: flex;
    flex-direction: column;
    background: ${colors.white};
    // box-shadow: 0px 3px 6px #0000001a;
    
 `;

export const stick = `
  top:0;
  left:0;
  right:0;
  bottom:0;
    `;

export const cardHeading = `
      font-size:18px;
      font-weight:${fontWeight.semiBold};
      color:${(props) => props.theme.colors.mainTextColor};
      display: block;
    `;

export const cardSubheading = `
    font-weight: ${fontWeight.light};
    font-size: 10px;
    color:${(props) => props.theme.colors.mainTextColor};
    display: block;
    `;

export const heading_32 = `
    font-weight:${fontWeight.semiBold};
    color:${(props) => props.theme.colors.mainTextColor};
    font-size:32px;
    line-height:34px;
    opacity: 1;
    `;

export const sideBorders = (theme, side = 'left') => `
    content:'';
    position:absolute;
    width:1px;
    height:18px;
    background-color:${theme == Theme.DARK ? colors.white : (props) => props.theme.colors.mainTextColor};
    opacity:0.2;
    top:50%;
    transform:translateY(-50%);
    ${side == 'left' ? 'left:0;' : 'right:0;'}
`;

export const Attention = styled.h1`
  color: ${colors.red};
  font-weight: ${fontWeight.bold};
  font-size: 32px;
  position: absolute;
  top: 50%;
  left: 50%;
  line-height: 1.1;
  text-align: center;
  transform: translate(-50%, -50%);
  width: 100%;
  padding: var(--padding);
  ${mq(Devices.laptop)} {
    font-size: 32px;
  }

  ${mq(Devices.tablet)} {
    font-size: 4vw;
  }
  ${mq(Devices.mobile)} {
    font-size: 6vw;
  } ;
`;

export const ListStructure = (theme) =>
  `
    position:relative;
    display:flex;
    width:100%;
    height:64px;
    justify-content:flex-start;
    align-items:center;
    background-color: ${theme == Theme.DARK ? (props) => props.theme.colors.mainTextColor : colors.white};
    font-size:13px;
    font-weight:${fontWeight.bold};
    color: ${theme == Theme.DARK ? colors.white : (props) => props.theme.colors.mainTextColor};

    > div:nth-of-type(n+1){
      position:relative;
      height:100%;
      display:flex;
      justify-content:center;
      align-items:center;
      flex-shrink:0;
    }

    > div:nth-of-type(1){
      width:50px;
    }

    > div:nth-of-type(2){
      width:50px;
    }

    > div:nth-of-type(3){
      width:${col(2.6, 12)};
      min-width:256px;
      justify-content:flex-start;
    }

    > div:nth-of-type(n+4){
      width:${col(1.3, 12)};
      min-width:141px;
      flex:1;
    }

    > div:nth-of-type(n+4){
      &::before{
          ${sideBorders(theme)}
      }
    }

    > div:nth-of-type(:last-child){
      &::before{
          ${sideBorders(theme)}
      }
      &::after{
        ${sideBorders(theme, 'right')}
      }

    }
`;


export const PageTitle = styled.h1`
    color:#2a848e;
    font-size: 24px;
    line-height: 1.5;
    font-weight: 500;
    margin-bottom: 8px;
`;


export const PageSubTitle = styled.span`
    display:block;
    color:#64748b;
    font-size: 16px;
    margin-bottom: 32px;
`;

export const Container = styled.div`
    background:#fff;
    box-shadow: 0 0 2px 2px rgba(0,0,0,0.05);
    border-radius: 8px;
    margin-bottom: 32px;
`;

export const ContainerTitleHeader = styled.div`
    border-bottom: 1px solid #0000001a;
    margin-bottom: 16px;
    padding:24px 24px 12px 24px;

    span{
      display:block;

      :nth-of-type(1){
        font-size: 16px;
      }
      :nth-of-type(2){
        font-size: 14px;
        color:#64748b;
      }
    }
`;